export const CLIENT_NAME = 'astex';